"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savePendingSpanTargets = savePendingSpanTargets;
const tslib_1 = require("tslib");
const index_1 = require("../index");
/**
 * Save all unique target collections referenced by pending two-way links
 * and bidirectional unlinks. Each target is saved with a
 * `spanLinkedPoleUuid` modification pointing to the source collection.
 *
 * After each successful target save, `finishEdit()` is called on the
 * target collection to drop its proxy state.
 *
 * This function should be called AFTER the source collection has been
 * saved successfully. If the source save failed, do not call this.
 */
function savePendingSpanTargets(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { sourceCollection, pendingTwoWayLinks, pendingBidirectionalUnlinks } = options;
        // Deduplicate target collections by ID
        const targetCollections = new Map();
        for (const link of pendingTwoWayLinks) {
            targetCollections.set(link.targetCollection.id, link.targetCollection);
        }
        for (const unlink of pendingBidirectionalUnlinks) {
            targetCollections.set(unlink.targetCollection.id, unlink.targetCollection);
        }
        const savedTargetIds = [];
        const failedTargetIds = [];
        for (const [targetId, targetCollection] of targetCollections) {
            try {
                yield index_1.Services.Collection.save(targetCollection, {
                    spanLinkedPoleUuid: sourceCollection.uuid,
                });
                targetCollection.finishEdit();
                savedTargetIds.push(targetId);
            }
            catch (error) {
                index_1.Services.Log.Logger.error(`Failed to save target collection ${targetId} after span link: ${error}`);
                failedTargetIds.push(targetId);
            }
        }
        return { savedTargetIds, failedTargetIds };
    });
}
//# sourceMappingURL=save.pending.span.targets.js.map